// The code in this file will load on every page of your site

$w.onReady(function () {
	$w("#headerTransitionPoint").onViewportLeave( () => {

	let slideOptions = {
		"duration": 100,
		"delay": 0,
		"direction": "top"
		};

	let fadeOptions = {
		"duration": 100,
		"delay": 0,
	};
	
	$w("#scrollingHeaderStrip").show('slide',slideOptions);
	$w("#defaultHeaderStrip").hide('fade',fadeOptions);
	
	} )

	$w("#headerTransitionPoint").onViewportEnter(() => {
    
	$w("#defaultHeaderStrip").show();
	$w("#scrollingHeaderStrip").hide();
	

	})
});